var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-intl-entry", style: _vm.cssVars }, [
    _c(
      "div",
      {
        staticClass: "mobile-intl-entry__card",
        on: { click: _vm.goInternational },
      },
      [
        _c("img", {
          staticClass: "mobile-intl-entry__bg",
          attrs: { src: _vm.bgImg, alt: "" },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mobile-intl-entry__content" }, [
      _c("div", { staticClass: "mobile-intl-entry__title" }, [
        _vm._v("国际专区"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mobile-intl-entry__desc" }, [
        _vm._v("国际交流 · 合作办学 · 课程资源"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }